import { render, staticRenderFns } from "./edit-day.vue?vue&type=template&id=36572e77&scoped=true"
import script from "./edit-day.vue?vue&type=script&lang=js"
export * from "./edit-day.vue?vue&type=script&lang=js"
import style0 from "./edit-day.vue?vue&type=style&index=0&id=36572e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36572e77",
  null
  
)

export default component.exports